import React from "react";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Trans, withTranslation } from "react-i18next";

import "./NavBar.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.lngs = {
      en: { nativeName: "English" },
      fr: { nativeName: "Français" },
    };
  }

  componentDidMount() {}

  render() {
    return (
      <Container maxWidth="lg">
        <div className="flex" style={{ height: "150px" }}>
          <Link to="/" className="noUnderline" style={{ marginBottom: "8px" }}>
            <div className="brand">VideoViews</div>
          </Link>

          <div className="navButtonsDiv">
            <Link to="/about" className="noUnderline" hidden>
              <Button className="Button" size="small">
                About
              </Button>
            </Link>
            <Link to="/features" className="noUnderline" hidden>
              <Button className="Button" size="small">
                Features
              </Button>
            </Link>
            <Link to="/pricing" className="noUnderline">
              <Button className="Button" size="small">
                <Trans>Pricing</Trans>
              </Button>
            </Link>
            <Link to="/login" className="noUnderline">
              <Button className="Button" size="small">
                <Trans>Log In</Trans>
              </Button>
            </Link>
            <Link to="/register" className="noUnderline">
              <Button className="Button ButtonPrimary" size="small">
                <Trans>Sign Up</Trans>
              </Button>
            </Link>

            {Object.keys(this.lngs).map((lng) => (
              <Link
                key={lng}
                className="noUnderline"
                to="#"
                hidden={this.props.i18n.language === lng}
              >
                <Button
                  className="Button"
                  size="small"
                  onClick={() => this.props.i18n.changeLanguage(lng)}
                >
                  {this.lngs[lng].nativeName}
                </Button>
              </Link>
            ))}
          </div>
        </div>
      </Container>
    );
  }
}

export default withTranslation()(withRouter(Index));
